/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/ThemesMenu',['MenuUI/Menu', 'util/NineSliceWrapper', 'absolute'],
	function (Menu, NineSliceWrapper, Absolute) {
		var ThemesMenu = function (config, game) {
			this.game = game;
			this.initThemesMenu(config);
		};

		ThemesMenu.prototype = Object.create(Menu.prototype);

		ThemesMenu.prototype.initThemesMenu = function (config) {
			config.width = Absolute.Coords.x(1890);
			config.height = Absolute.Coords.y(740);
			config.tilePaddingX = Absolute.Coords.x(120);
			config.startY = Absolute.Coords.y(70);
			Menu.call(this, config);

			this.initBackground('xl');
			this.container.x = Absolute.Coords.x(70);
			this.container.y = Absolute.Coords.y(20);
			this.previousLayoutType = 'xl';
		};

		ThemesMenu.prototype.initBackground = function (layoutType) {
			if (this.background) this.removeChild(this.background);
			var width = layoutType === 'xl' ? this.config.width : Absolute.Coords.x(1080),
				height = layoutType === 'xl' ? this.config.height : Absolute.Coords.y(1050);
			var background = new NineSliceWrapper(
				'mainmenu/themes_menu_background.png', width, height,
				30, 30, 20, 20
			);
			this.background = background;
			this.addChildAt(background, 0);
		};

		ThemesMenu.prototype.handleResize = function () {
			Menu.prototype.handleResize.call(this);
			var layoutConfig = this.getLayoutConfig();
			if (this.previousLayoutType !== layoutConfig.type) {
				this.initBackground(layoutConfig.type);
				this.previousLayoutType = layoutConfig.type;
			}
		};

		return ThemesMenu;
	});

